import { render, staticRenderFns } from "./GoKegg.vue?vue&type=template&id=c936cfd2&scoped=true"
import script from "./GoKegg.vue?vue&type=script&lang=js"
export * from "./GoKegg.vue?vue&type=script&lang=js"
import style0 from "./GoKegg.vue?vue&type=style&index=0&id=c936cfd2&prod&scoped=true&lang=css"
import style1 from "./GoKegg.vue?vue&type=style&index=1&id=c936cfd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c936cfd2",
  null
  
)

export default component.exports